import React, { memo, useMemo } from 'react'
import { useIntl } from 'react-intl'
import classNames from 'classnames'
import { Fading } from '@/components/ui/animations'
import Button from '@/components/ui/Button'
import type { IButtonProps } from '@/components/ui/Button/interfaces'
import { injectMessages } from '@/logic/translation/utils'
import type { IUserRegionSelectConfirmProps } from '../types'
import messages from './messages.json'
import './styles.scss'

injectMessages(messages)

const UserRegionSelectConfirmDesktop: React.FC<IUserRegionSelectConfirmProps> = props => {
  const { className, region, isShown, onAccept, onDecline } = props

  const { formatMessage } = useIntl()

  const acceptBtnProps: IButtonProps = useMemo(
    () => ({
      modifiers: ['small', 'green'],
      children: formatMessage({ id: 'userRegionSelectConfirmDesktop.btn.accept' }),
      onClick: onAccept,
    }),
    [onAccept, formatMessage],
  )

  const declineBtnProps: IButtonProps = useMemo(
    () => ({
      modifiers: ['small', 'outline'],
      children: formatMessage({ id: 'userRegionSelectConfirmDesktop.btn.decline' }),
      onClick: onDecline,
    }),
    [onDecline, formatMessage],
  )

  return (
    <Fading isVisible={isShown}>
      <div className={classNames('userRegionSelectConfirmDesktop', className)}>
        <h4 className="userRegionSelectConfirmDesktop__title">{formatMessage({ id: 'userRegionSelectConfirmDesktop.title' })}</h4>
        <h4 className="userRegionSelectConfirmDesktop__region-text">{region.name}</h4>
        <div className="userRegionSelectConfirmDesktop__actions">
          <Button {...acceptBtnProps} />
          <Button {...declineBtnProps} />
        </div>
      </div>
    </Fading>
  )
}

export default memo(UserRegionSelectConfirmDesktop)
